/** Section wrapper with eyebrow label for design system demos. */

const eyebrowStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--color-text-muted)',
  marginBottom: 20,
};

export default function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 56 }}>
      <p style={eyebrowStyle}>{label}</p>
      {children}
    </section>
  );
}
